module.exports = __webpack_public_path__ + "img/reseau-astuce.267315f7.png";